module.exports = __webpack_public_path__ + "static/EM0-0291ed8161c8c3e0531259d4d873fa14.png";